export default [
    {
        path: '/duplicates',
        name: 'duplicates',
        component: () => import(/* webpackChunkName: "duplicates" */ '../views/Duplicates.vue'),
        meta: {
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
];
